import { render, staticRenderFns } from "./searchZinn.vue?vue&type=template&id=1aeab584&scoped=true"
import script from "./searchZinn.vue?vue&type=script&lang=js"
export * from "./searchZinn.vue?vue&type=script&lang=js"
import style0 from "./searchZinn.vue?vue&type=style&index=0&id=1aeab584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aeab584",
  null
  
)

export default component.exports